import React, { useState } from 'react';
import { Form, Button, Container, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { addNews } from '../../services/newsService';
import { message } from 'antd'; // Add antd message

const getCurrentDateTimeLocal = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const NewsForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    newsCategoryId: 'af000611-9cf6-e167-676b-46eb0606d4b9',
    date: getCurrentDateTimeLocal(),
    header: '',
    detail: '',
    shortDetail: '',
    pictureUrl: '',
    picture: null,
    refererLink: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if file is an image
      if (!file.type.startsWith('image/')) {
        message.warning('Lütfen geçerli bir resim dosyası seçin');
        e.target.value = '';
        return;
      }
      // Check image size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        message.warning('Resim dosyası 5MB\'dan büyük olamaz');
        e.target.value = '';
        return;
      }

      setFormData(prevState => ({
        ...prevState,
        picture: file
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await addNews(formData);
      if (response.isSuccess) {
        message.success('Haber başarıyla eklendi!');
        
        setTimeout(() => {
          navigate('/news');
      }, 1500);
      } else {
        const errorMessage = response.resultMessage || 'Haber eklenirken bir hata oluştu.';
        message.error(errorMessage);
      }
    } catch (error) {
      console.error('Error adding news:', error);
      const errorMessage = error.response?.data?.message || 'Haber eklenirken bir hata oluştu.';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>


      <Card className="mt-4 mb-4">
        <Card.Body>
          <h2 className="mb-4">Yeni Haber Ekle</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Haber Başlığı</Form.Label>
              <Form.Control
                type="text"
                name="header"
                value={formData.header}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Haber Tarihi</Form.Label>
              <Form.Control
                type="datetime-local"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Detay</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="detail"
                value={formData.detail}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Haber Görseli</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Kısa Detay</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                name="shortDetail"
                value={formData.shortDetail}
                onChange={handleChange}
                placeholder="Kısa detay giriniz (opsiyonel)"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Referans Link</Form.Label>
              <Form.Control
                type="text"
                name="refererLink"
                value={formData.refererLink}
                onChange={handleChange}
                placeholder="Referans link giriniz"
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-2">
              <Button 
                variant="secondary" 
                onClick={() => navigate('/news')}
                disabled={loading}
              >
                İptal
              </Button>
              <Button 
                variant="primary" 
                type="submit"
                disabled={loading}
              >
                {loading ? 'Ekleniyor...' : 'Kaydet'}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default NewsForm;
